import checkout from "./form";

const {
  formField: { title, introText, curator, travelStyle, days, destination, images, logo },
} = checkout;

const initialValues = {
  // partner page
  [title.name]: "",
  [introText.name]: "",
  [curator.name]: null,
  [destination.name]: null,
  [travelStyle.name]: "",
  [days.name]: 1,
  [images.name]: [],
  [logo.name]: "",
};

export default initialValues;
